/** SVG donut with centre total and legend rows. segments: [{label, value, color}] */
export default function DonutChart({ segments, centerLabel = 'Total' }) {
  const total = segments.reduce((a, s) => a + s.value, 0);
  const R = 52, C = 2 * Math.PI * R;
  let offset = 0;
  return (
    <div className="d-flex flex-wrap align-items-center gap-4">
      <svg width="150" height="150" viewBox="0 0 140 140" role="img" aria-label={`Donut chart, total ${total}: ${segments.map((s) => `${s.label} ${s.value}`).join(', ')}`}>
        <g transform="rotate(-90 70 70)">
          <circle cx="70" cy="70" r={R} fill="none" stroke="#EEF2F7" strokeWidth="16" />
          {segments.map((s) => {
            const len = total ? (s.value / total) * C : 0;
            const el = (
              <circle key={s.label} cx="70" cy="70" r={R} fill="none" stroke={s.color} strokeWidth="16"
                strokeDasharray={`${len} ${C - len}`} strokeDashoffset={-offset} />
            );
            offset += len;
            return el;
          })}
        </g>
        <text x="70" y="68" textAnchor="middle" fontSize="22" fontWeight="700" fill="#0B1F4B">{total}</text>
        <text x="70" y="86" textAnchor="middle" fontSize="10" fill="#6B7280">{centerLabel}</text>
      </svg>
      <ul className="list-unstyled mb-0 flex-grow-1" style={{ minWidth: 160 }}>
        {segments.map((s) => (
          <li key={s.label} className="d-flex align-items-center justify-content-between small py-1">
            <span><span className="cb-dot" style={{ background: s.color }} />{s.label}</span>
            <span className="fw-medium">{s.value} <span className="text-muted">({total ? Math.round((s.value / total) * 100) : 0}%)</span></span>
          </li>
        ))}
      </ul>
    </div>
  );
}
